// extracted by mini-css-extract-plugin
export var cardIcon = "_9z-5";
export var cardIconUnframed = "_9z-9";
export var checkboxCard = "_9z-0";
export var checkboxCardSelected = "_9z-4";
export var disabled = "_9z-2";
export var interactive = "_9z-1";
export var outerBorder = "_9z-3";
export var spacerMedium = "_9z-8";
export var spacerSmall = "_9z-7";
export var spacerXsmall = "_9z-6";